<template>
  <template v-if="this.block && !this.loading">
    <div class='max-w-[1216px] mx-auto'>
      <div class="mt-14 mb-6">
        <h2 class="serie-block-title">
          {{ this.block.title }}
        </h2>
        <div v-html="this.block.content" class="serie-block-content prose max-w-full text-gray-10"></div>
      </div>

      <div id="post-item-collection" class="flex-1">
        <template v-for="(post, index) in this.block.posts" :key="post.id">
          <post-item
            :post="post"
            :list-name="'serie:' + serieId"
            :ref="(el) => bindSerieBlockImpression(post, index, el)"
          ></post-item>
        </template>
      </div>
    </div>
  </template>
  <div v-else-if="this.loading" class="flex justify-center my-10">
    <img src="../../images/icons/loading.png" class="w-6 h-6 icon loading-icon"/>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { useModuleImpression } from "../utils/useModuleImpression";

// 不同 series 的模型總數差異很大，用絕對張數取樣（例如每 8 張）無法跨 series 比較捲動深度，
// 因此改用百分比里程碑（25/50/75/100%），依每個 block 實際的模型總數換算成張數索引。
// milestone_pct 是這個 module 專屬的欄位，GTM 端要另外設定，見 docs/analytics_tracking.md。
const IMPRESSION_MILESTONES = [25, 50, 75, 100];

function computeMilestonePositions(total) {
  const positionToPct = new Map();
  if (!total) return positionToPct;

  IMPRESSION_MILESTONES.forEach((pct) => {
    const position = Math.ceil((total * pct) / 100) - 1;
    // 當 total 很小時，多個百分比門檻會落在同一張卡片上，取該卡片對應的最高百分比。
    positionToPct.set(position, pct);
  });

  return positionToPct;
}

export default defineComponent({
  props: ['serieBlockId', 'serieId'],
  setup() {
    const { bindImpression } = useModuleImpression()
    return { bindImpression }
  },
  data() {
    return {
      loading: false,
      block: null
    };
  },
  computed: {
    milestonePositions() {
      return computeMilestonePositions(this.block?.posts?.length);
    }
  },
  mounted() {
    this.getSerieBlock()
  },
  methods: {
    bindSerieBlockImpression(post, index, el) {
      if (!this.milestonePositions.has(index)) return;

      this.bindImpression(post.id, el ? el.$el : null, this.serieBlockImpressionPayload(post, index));
    },
    serieBlockImpressionPayload(post, index) {
      return {
        page_type: 'series',
        module: 'serie_block',
        landing_path: window.location.pathname,
        target_type: 'post',
        target_id: post.id,
        position: index,
        milestone_pct: this.milestonePositions.get(index),
      };
    },
    async getSerieBlock(){
      if (this.loading) return;

      this.loading = true;

      try {
        const api_path = '/api/v1/serie_blocks/' + this.serieBlockId
        const response = await fetch(api_path);

        if (response.ok) {
          const data = await response.json();
          this.block = data['data']
        }
      } catch (error) {
      } finally {
        this.loading = false;
      }
    }
  }
});
</script>
